import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DetailproduitPageRoutingModule } from './detailproduit-routing.module';

import { DetailproduitPage } from './detailproduit.page';

import { IonicSelectableModule } from 'ionic-selectable';
import { ExpandableComponent } from '../../components/expandable/expandable.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DetailproduitPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [DetailproduitPage, ExpandableComponent]
 
})
export class DetailproduitPageModule {}
